import React, { useContext } from 'react';
import { LoginAction, LoginError, LoginState } from './loginReducer';

export type LoginContext = {
  state: LoginState;
  dispatch: React.Dispatch<LoginAction>;
};

export const LoginContext = React.createContext<LoginContext | null>(null);

export const useLoginContext: () => [
  LoginState,
  React.Dispatch<LoginAction>,
] = () => {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error('Context not found' + LoginContext);
  }
  return [context.state, context.dispatch];
};

export const useLogin: () => LoginState = () => {
  const [state] = useLoginContext();
  return state;
};

export const useLoginError = (): LoginError | null => {
  const loginState = useLogin();
  const stateData = loginState.data;
  if (stateData.type !== 'VERIFYING_OTP_SUCCESS') {
    return stateData.error ?? null;
  }
  return null;
};
